export const STORAGE_KEYS = {
  // Authentication
  ACCESS_TOKEN: 'skai1_access_token',
  REFRESH_TOKEN: 'skai1_refresh_token',
  USER_DATA: 'skai1_user_data',

  // Session Management
  LAST_ACTIVITY: 'skai1_last_activity',
  SESSION_START: 'skai1_session_start',
  SESSION_WARNING_SHOWN: 'skai1_session_warning_shown',

  // User Preferences
  THEME: 'skai1_theme',
  LANGUAGE: 'skai1_language',
  SIDEBAR_COLLAPSED: 'skai1_sidebar_collapsed',
  NOTIFICATIONS_ENABLED: 'skai1_notifications_enabled',

  // Application State
  LAST_ROUTE: 'skai1_last_route',
  FORM_DRAFTS: 'skai1_form_drafts',
  TABLE_PREFERENCES: 'skai1_table_preferences',
  DASHBOARD_LAYOUT: 'skai1_dashboard_layout',

  // Cache
  CACHE_PREFIX: 'skai1_cache_',
  API_CACHE: 'skai1_api_cache',
  USER_CACHE: 'skai1_user_cache',

  // Feature Flags
  FEATURE_FLAGS: 'skai1_feature_flags',
  BETA_FEATURES: 'skai1_beta_features',

  // Analytics
  ANALYTICS_ID: 'skai1_analytics_id',
  TRACKING_CONSENT: 'skai1_tracking_consent',

  // Device ID
  DEVICE_ID: 'skai1_device_id',
};
